import styled, { css } from "styled-components";
import { animated } from "react-spring";

interface IpropsContainer {
  type?: "success" | "error" | "info";
  hasDescription: boolean;
}

const containerTypeVariations = {
  success: css`
    background: var(--success);
    color: var(--success-text);
  `,
  error: css`
    background: var(--error);
    color: var(--error-text);
  `,
  info: css`
    background: var(--info);
    color: var(--info-text);
  `,
};

export const Container = styled(animated.div)<IpropsContainer>`
  width: 360px;
  position: relative;
  padding: 16px 30px 16px 16px;
  border-radius: 10px;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  z-index: 99999;
  & + div {
    margin-top: 8px;
  }
  ${(props) => containerTypeVariations[props.type || "info"]}

  > svg {
    margin: 4px 12px 0 0;
  }

  div {
    flex: 1;

    p {
      margin-top: 4px;
      font-size: 14px;
      opacity: 0.8;
      line-height: 20px;
    }
  }

  button {
    position: absolute;
    right: 16px;
    top: 19px;
    opacity: 0.6;
    border: 0;
    background: transparent;
    color: inherit;
  }

  ${(props) =>
    !props.hasDescription &&
    css`
      align-items: center;

      svg {
        margin-top: 0;
      }
    `}
`;
